define(
    'checkPreInit/cacheBuster',[
        'atn/atn', 'jquery', 'lodash', 'dataSource/uiVersion',
        'common/cleanBFCache', 'common/config', './loadingErrors'
    ],
    function(atn, $, _, uiVersion, cleanBFCache, config, errors) {
        'use strict';

        var cacheStaircase = atn.utils.createWaterfall([
                getVersions, checkBuildVersion, checkRemoteApiVersion
            ]),
            retestAPI = atn.utils.createWaterfall([getVersions, checkRemoteApiVersion]);

        return {
            cacheStaircase: cacheStaircase,
            retestAPI: retestAPI,
            getVersions: getVersions,
            checkBuildVersion: checkBuildVersion,
            checkRemoteApiVersion: checkRemoteApiVersion
        };

        function getVersions(data, next) {
            $.when(
                uiVersion.getUIVersion()
            ).then(
                function(uiVersion) {
                    data.uiVersion = uiVersion;
                    next();
                },
                function() {
                    next(errors.FETCH_VERSION);
                }
            );
        }

        function checkBuildVersion(data, next) {
            var versionInfo = data.uiVersion,
                requiredVersion = versionInfo.id,
                urlParts = atn.utils.parseURL(window.location.href),
                givenVersion = urlParts.query.id,
                requiredURL;
            if (requiredVersion !== givenVersion) {
                //   in case given URL in not same as current URL changing it
                //   and redirecting it new web-page
                requiredURL = atn.utils.createURL(window.location.href, {
                    id: requiredVersion
                });
                next(errors.BUILD_MISMATCH);
            } else {
                next();
            }
        }

        function checkRemoteApiVersion(data, next) {
            atn.showErrorPage = data.uiVersion.API !== config.apiVersion;
            next(atn.showErrorPage ? errors.SERVER_API_MISMATCH : null);
        }

    }
);
